import React, { useState, useEffect } from 'react';
// import useCustomHooks from './customHooks';
// const url='http://localhost:5000/kens/api/v2'
import { pictures } from './gadgets';
const TrendingImg = () => {
    // const { files } = useCustomHooks(url)

    const [value, setValue] = useState(0);
    useEffect(() => {
        const lastIndex = pictures.length - 1
        if (value>lastIndex) {
            setValue(0)
        }
        if (value<0) {
            setValue(lastIndex)
        }
    }, [ value])
    useEffect(() => {
     const slide=   setInterval(() => {
         setValue(value + 1)
        }, 6000);
        return () => {
            clearInterval(slide)
        }
    },[value])
  return (
      <>
          <div className='slide-text'>
              <h1 className='trendingtxt'>Top Art.</h1>
          </div>
          <div className='slide-cont'>

              {pictures.map((img, index) => {
                  let position = 'next'
                  if (value===index) {
                    position='active'
                  }
                  if (index===value - 1 || index===0 && index===pictures.length -1) {
                            position='last'
                  }
                  const { name, image } = img
                  return (
                    
                          
                      <main key={index} className={position}>
                          <img className='image' src={image} alt='images' />
                        
                          </main> 
                        
               )
           })}   
      </div>
    </>
  );
}

export default TrendingImg;
